export default __webpack_public_path__ + "static/media/Wawanesa_Assurance_blue.0ffadf55.svg";